import { normalizeCodeValue } from "./codeUtils";

export const collectHierarchyEmployees = (payload, managerInfinityCode) => {
    const visited = new Set();
    const results = [];
    const managerCodeNormalized = normalizeCodeValue(managerInfinityCode);

    const enqueueChildren = (possibleChildren) => {
        if (!possibleChildren) return [];
        if (Array.isArray(possibleChildren)) return possibleChildren;
        if (typeof possibleChildren === "object") {
            if (Array.isArray(possibleChildren.data)) {
                return possibleChildren.data;
            }
            if (Array.isArray(possibleChildren.items)) {
                return possibleChildren.items;
            }
        }
        return [];
    };

    const collect = (node) => {
        if (!node || typeof node !== "object") return;

        const primaryCode =
            node.infinityCode ??
            node.infinity_code ??
            node.code ??
            node.employeeCode ??
            node.id ??
            node.employeeId ??
            null;

        const normalizedCode = normalizeCodeValue(primaryCode);

        const shouldInclude =
            normalizedCode &&
            (!managerCodeNormalized || normalizedCode !== managerCodeNormalized);

        if (shouldInclude && !visited.has(normalizedCode)) {
            visited.add(normalizedCode);
            results.push(node);
        }

        const childCandidates = [
            node.children,
            node.subordinates,
            node.directReports,
            node.employees,
            node.nodes,
            node.hierarchy,
            node.reports,
        ];

        childCandidates.forEach((childSet) => {
            const queue = enqueueChildren(childSet);
            queue.forEach((child) => collect(child));
        });
    };

    const initialCollections = enqueueChildren(payload);
    if (Array.isArray(payload?.hierarchy)) {
        initialCollections.push(...payload.hierarchy);
    }
    if (Array.isArray(payload?.data?.hierarchy)) {
        initialCollections.push(...payload.data.hierarchy);
    }

    if (initialCollections.length === 0 && payload && typeof payload === "object") {
        collect(payload);
    } else {
        initialCollections.forEach((node) => collect(node));
    }

    return results;
};